<script>
export default {
    name: "DateRange",
    props: {
        dateRange: {
            type: Array,
            default: null
        },
        title: {
            type: String,
            default: "טווח תאריכים"
        },
        description: {
            type: String,
            default: "בחר טווח תאריכים"
        },
        touchUI: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        updateDate() {
            this.$emit('updateDate', this.dateRange);
        }
    },
}
</script>


<template>
    <div>
        <Card style="width: 25rem; margin-bottom: 2em">
            <template #title>
               {{title}}
            </template>
            <template #content>
                <Calendar
                        :touchUI="touchUI"
                        :showButtonBar="true"
                        dateFormat="dd.mm.yy"
                        selectionMode="range"
                        v-model="dateRange"
                        :placeholder="description"
                        @input="updateDate"
                />
            </template>
        </Card>
    </div>
</template>

<style scoped>

</style>
